import './App.css';
import CssBaseline from '@material-ui/core/CssBaseline';
// import Typography from '@material-ui/core/Typography';
// import Container from '@material-ui/core/Container';

import CardContainerComponent from './components/card-container.component';

function App() {
  return (
    <>
      <CssBaseline />
      <CardContainerComponent />
    </>
  );
}

export default App;
